
export const headCells = [
    { title: 'Id', width: 200 },
    { title: 'Type', width: 300 },
    { title: 'Text', width: 300 },
    { title: 'Created', width: 100 },
    { title: '', width: 150 },
];
